// @core/api/endpoints/form/create_form_submission.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateFormSubmissionRequest,
  FormSubmissionResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Submit form response
 * Creates a new submission for a published form. Available to anonymous users if the form allows it.
 * @public This endpoint does not require authentication
 */
export async function CreateFormSubmission(
  form_id: string,
  data: CreateFormSubmissionRequest,
  options?: RequestOptions
): Promise<FormSubmissionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id/submissions`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.post<FormSubmissionResponse>(requestPath, data, requestOptions);
}
